/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { CourseModuleSettingsOutput } from './courseModuleSettingsOutput';

export type GenericApiResponseCourseModuleSettingsData = CourseModuleSettingsOutput | null;
